import SSView from 'core/src/views/base/ss-view';
import cardRowTemplate from 'text!core/src/templates/notifications/_card-row.mustache';

const NotificationItemView = SSView.extend({

  tagName: 'li',

  className: 'notification-row ss-card',

  template: cardRowTemplate,

  templateData: {},
});

export default NotificationItemView;

